<template>
  <div class="pt-2 sm:p-4 " v-if="highlightedColivings.length > 0">
    <div class="bg-white rounded-xl shadow-sm p-4 border border-gray-200">
      <div class="flex items-start justify-between mb-4">
        <div class="grow">
          <h3 class="text-md font-semibold text-gray-800">{{ $t('agentDashboard.colivingsHighlighted.title') }}</h3>
        </div>
        <!-- Enlace para móvil - misma fila que el h3 -->
        <div class="sm:hidden">
          <button 
            @click="$emit('go-to-coliving')" 
            class="text-xs font-medium text-purple-600 hover:text-purple-800 transition-colors"
          >
            {{ $t('agentDashboard.colivingsHighlighted.viewAll') }}
          </button>
        </div>
      </div>

      <div class="space-y-3 mb-4">
        <div 
          v-for="coliving in highlightedColivings" 
          :key="coliving.id" 
          @click="$emit('go-to-coliving', coliving.id)"
          class="cursor-pointer"
        >
          <a class="text-xs font-semibold text-gray-900 hover:text-purple-700">{{ coliving.title }}</a>
          <p class="text-xs text-gray-600 mt-1">
            {{ coliving.rooms?.length || 0 }} {{ $t('agentDashboard.colivingsHighlighted.rooms') }} &middot; {{ getOccupiedRoomsCount(coliving) }} {{ $t('agentDashboard.colivingsHighlighted.occupied') }}
            <span v-if="getPreAssignedRoomsCount(coliving) > 0">&middot; {{ getPreAssignedRoomsCount(coliving) }} {{ $t('agentDashboard.colivingsHighlighted.preAssigned') }}</span>
          </p>
        </div>
      </div>

      <!-- Botón para desktop - debajo de la lista -->
      <button 
        @click="$emit('go-to-coliving')" 
        class="hidden sm:block w-full py-2 px-4 text-sm font-medium text-center text-gray-700 bg-white border border-gray-300 rounded-full hover:bg-gray-100 transition-colors"
      >
        {{ $t('agentDashboard.colivingsHighlighted.viewAllColivings') }}
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  highlightedColivings: {
    type: Array,
    default: () => []
  }
});

defineEmits(['go-to-coliving']);

const getOccupiedRoomsCount = (coliving) => {
  if (!coliving.rooms || !Array.isArray(coliving.rooms)) {
    return 0;
  }
  return coliving.rooms.filter(room => room.status === 'ocupada').length;
};

const getPreAssignedRoomsCount = (coliving) => {
  if (!coliving.applications || !Array.isArray(coliving.applications)) {
    return 0;
  }
  const preAssignedStatuses = ['pre_approved', 'owner_signed', 'applicant_signed', 'contract_signed', 'payment_completed'];
  return coliving.applications.filter(app => 
    preAssignedStatuses.includes(app.status)
  ).length;
};
</script> 